module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNddPoXQzPJCSJzNvsHLGnlw.2d1940c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/帽子/AgAABXq0GNddPoXQzPJCSJzNvsHLGnlw.jpeg
// module id = tWga
// module chunks = 0